module.exports = __webpack_public_path__ + "static/media/Tom_Brady.ba721647.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Tom_Brady.jpg
// module id = 418
// module chunks = 0